module.exports = __webpack_public_path__ + "static/media/demo00.4ee4be83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/demo00.png
// module id = 817
// module chunks = 0